import {
  put, takeLatest, takeEvery, select, all,
} from 'redux-saga/effects';
import _ from 'lodash';
import {
  TeammoApi,
  normalize,
  compilePaginationObject,
} from 'app/utils/redux/helpers';
import {
  matchPaymentSchema,
  matchPaymentListSchema,
} from 'app/utils/redux/schemas';
import { handleError } from 'app/utils/handlers/handleError';
import { loadingStart, loadingFinish } from 'app/ducks/loading/actions';
import { sagaActions } from 'app/ducks/matchPayments/actions';
import { getPaymentEvent } from 'app/ducks/paymentEvents/actions';
import { getCompetition } from 'app/ducks/competitions/actions';
import { MatchPaymentsActionTypes as types } from 'app/ducks/matchPayments/types';

function* getMatchPaymentSaga(action): any {
  yield put(sagaActions.getMatchPaymentPending());
  const [error, response] = yield (
    yield (yield TeammoApi(yield select()))
  ).organisationMatchPayments.show(action.payload);
  if (response) {
    const normalizedResponse = normalize(response, matchPaymentSchema);
    yield put(sagaActions.getMatchPaymentSuccess(normalizedResponse));
    const pc = normalizedResponse.entities.matchPayments[normalizedResponse.result];

    if (!_.isEmpty(pc.fixtureMatch.id)) {
      yield put(yield getPaymentEvent(pc.fixtureMatch.id));
    }

    if (!_.isEmpty(pc.competition?.id)) {
      yield put(yield getCompetition(pc.competition.id));
    }
    return pc;
  }
  yield put(
    handleError(
      error,
      sagaActions.getMatchPaymentFailed(_.isEmpty(error) ? {} : error.response.data.errors),
    ),
  );
  return null;
}

function* updateMatchPaymentSaga(action): any {
  yield put(sagaActions.updateMatchPaymentPending(action.payload));
  const [error, response] = yield (
    yield TeammoApi(yield select())
  ).organisationMatchPayments.update(
    action.payload.data,
    action.payload.paymentEventDashboardId,
  );

  if (response) {
    const normalizedResponse = normalize(response, matchPaymentSchema);

    yield put(sagaActions.updateMatchPaymentSuccess(normalizedResponse));

    if (action.payload.paymentEventId !== undefined) {
      yield put(
        yield getPaymentEvent(
          action.payload.paymentEventId,
          action.payload.paymentEventDashboardId,
        ),
      );
    }
  } else {
    yield put(
      handleError(
        error,
        sagaActions.updateMatchPaymentFailed(
          _.isEmpty(error) ? {} : error.response.data.errors,
        ),
      ),
    );
  }
}

function* getAllMatchPaymentsSaga(action): any {
  yield put(
    sagaActions.getAllMatchPaymentsPending(
      action.payload.compile ? action.payload.pagination : {},
    ),
  );
  yield put(loadingStart());

  const paginationObject = action.payload.compile
    ? compilePaginationObject(
      yield select((state) => state.matchPayments.pagination),
    )
    : action.payload.pagination;

  const [error, response] = yield (yield (yield TeammoApi(yield select()))).organisationMatchPayments.list(paginationObject);

  if (response) {
    const normalizedResponse = normalize(response, matchPaymentListSchema);
    yield put(
      sagaActions.getAllMatchPaymentsSuccess(
        normalizedResponse,
        response.meta,
      ),
    );
    yield put(loadingFinish());
  } else {
    yield put(
      handleError(
        error,
        sagaActions.getAllMatchPaymentsFailed(_.isEmpty(error) ? {} : error.response.data.errors),
      ),
    );
  }
}

/* ********************************* SAGA WATCHERS ********************************* */

function* getMatchPaymentSagaWatcher(): any {
  yield takeEvery(
    types.GET_MATCH_PAYMENT_REQUESTED,
    getMatchPaymentSaga,
  );
}

function* updateMatchPaymentSagaWatcher(): any {
  yield takeLatest(types.UPDATE_MATCH_PAYMENT_REQUESTED, updateMatchPaymentSaga);
}

function* getAllMatchPaymentsSagaWatcher(): any {
  yield takeLatest(
    types.GET_ALL_MATCH_PAYMENTS_REQUESTED,
    getAllMatchPaymentsSaga,
  );
}

export default function* root(): any {
  yield all([
    getMatchPaymentSagaWatcher(),
    getAllMatchPaymentsSagaWatcher(),
    updateMatchPaymentSagaWatcher(),
  ]);
}
